import { useEffect, useMemo } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';

import { Switch as SwitchSchema } from '@/schemas/sceneDataSchema';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { BaseSwitch } from './BaseSwitch';

export const SwitchFormElement = ({ form, component }: { form: UseFormReturn; component: SwitchSchema }) => {
  const fieldName = useMemo(() => encodeFieldKey(component), [component]);

  // Default value to the "off" option if it isn't already a valid option
  useEffect(() => {
    const optionValues = component.options.map(({ value }) => value);
    if (!optionValues.includes(form.getValues(fieldName) as SwitchSchema['options'][0]['value'])) {
      form.setValue(fieldName, component.options[1].value);
    }
  }, [component.options, fieldName, form]);

  return (
    <Controller
      name={fieldName}
      control={form.control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <BaseSwitch
            id={fieldName}
            checked={field.value == component.options[0].value}
            onChange={(checked) => field.onChange(checked ? component.options[0].value : component.options[1].value)}
            name={field.name}
            inputRef={field.ref}
          />
        </FormControl>
      )}
    />
  );
};
